import type { BaseElement } from 'slate';

import type {
  AlineContentBlock,
  AlineText,
  LocationIdProps,
  SuggestedInstructionFieldEdit,
} from '../../internal';

export const instructionFieldElementType = 'instructionField' as const;
export type InstructionFieldElementType = typeof instructionFieldElementType;

export type InlineInstructionFieldVariant = 'PAGE' | 'NUMPAGES' | 'REF' | 'PAGEREF' | 'NOTEREF';
export type BlockInstructionFieldVariant = 'TOC';
export type InstructionFieldVariant = InlineInstructionFieldVariant | BlockInstructionFieldVariant;

export interface InstructionFieldElementInterface<
  T extends InstructionFieldVariant,
> extends BaseElement {
  instruction: T;
  switches: string;
  type: InstructionFieldElementType;
  suggestedEdits?: SuggestedInstructionFieldEdit[] | null;
}

export interface InlineInstructionFieldElement extends InstructionFieldElementInterface<InlineInstructionFieldVariant> {
  children: AlineText[];
}

export interface BlockInstructionFieldElement
  extends InstructionFieldElementInterface<BlockInstructionFieldVariant>, LocationIdProps {
  children: AlineContentBlock[];
}

export type InstructionFieldElement = InlineInstructionFieldElement | BlockInstructionFieldElement;
